<template>
  <div class="about">
    <div class="about-wrap">
      <div class="about-head">
        <img src="../../assets/images/mine/about-head.png" alt="" />
      </div>
      <div class="cell-list">
        <van-cell
          title="关于我们"
          is-link
          @click="$router.push({ name: 'AboutUs' })"
        />
        <van-cell
          title="使用帮助"
          is-link
          @click="$router.push({ name: 'UsingHelp' })"
        />
        <van-cell
          title="建议意见"
          is-link
          @click="$router.push({ name: 'Feedback' })"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.about {
  background: #f9f9f9;
  height: 100%;
  .about-wrap {
    padding: 0 20px;
    .about-head {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 191px;
      img {
        width: 205px;
        height: 76px;
      }
    }
    .cell-list {
      box-shadow: 0px 3px 6px rgba(5, 75, 27, 0.2);
      opacity: 1;
      border-radius: 8px;
      overflow: hidden;
    }
  }
}
</style>
<style lang="scss">
.cell-list {
  .van-cell__title {
    text-align: left;
  }
}
</style>
